export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "/img/hero.webp",
  studio: "/img/studio.webp",
  lifestyle: "/img/lifestyle.webp",
  box: "/img/box.webp",
  mist: "/img/mist.webp",
  airfryer: "/img/airfryer.webp",
  pour: "/img/pour.webp",
  parts: "/img/parts.webp",
};

export const PRODUCT = {
  id: "omnimist-2in1-sprayer-470",
  name: "OmniMist™ 2-in-1 Glass Oil Sprayer & Dispenser",
  capacity: "470ml",
  price: 349,
  compareAt: 599,
  rating: 4.9,
  reviews: "12,400+",
};

export const SAVE_PCT = Math.round(((PRODUCT.compareAt - PRODUCT.price) / PRODUCT.compareAt) * 100);

// COD handling fee per order — COD costs ₹40 more so customers prefer prepaid (must match COD_FEE in backend server.py)
export const COD_FEE = 40;
export const PREPAID_PCT = 5; // extra discount on Pay Online orders
export const prepaidNet = (n) => n - Math.round(n * (PREPAID_PCT / 100));

// COD prices per bundle — what customers see by default (must match COD_TOTALS in backend server.py)
export const COD_TOTALS = { 1: 389, 2: 729, 3: 999 };
export const codLineTotal = (qty) => COD_TOTALS[qty] ?? comboLineTotal(qty) + COD_FEE * qty;

// Combo tiers — Buy 2 / Buy 3 bundle pricing (must match COMBO_TOTALS in backend server.py)
export const COMBOS = [
  { qty: 1, price: 349, save: 0 },
  { qty: 2, price: 649, save: 49 },
  { qty: 3, price: 899, save: 148 },
];
export const comboLineTotal = (qty) => (qty === 2 ? 649 : qty === 3 ? 899 : PRODUCT.price * qty);
export const comboUnitPrice = (qty) =>
  qty === 2 ? 649 / 2 : qty === 3 ? Math.round((899 / 3) * 100) / 100 : PRODUCT.price;

export const fmt = (n) => `₹${Math.round(n).toLocaleString("en-IN")}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const MARQUEE_ITEMS = [
  "100% Safe Borosilicate Glass",
  "Use 75% Less Oil",
  "No-Drip Spout",
  "Perfect for Air Fryers",
  "Big 470ml Bottle",
  "Fine Mist in 0.2 Seconds",
];

export const GALLERY = [
  {
    img: IMAGES.studio,
    title: "The OmniMist, in the light",
    caption: "Clean studio look · Green cap, clear glass",
    span: "md:col-span-5 md:row-span-2",
    aspect: "aspect-[4/5] md:aspect-auto md:h-full",
  },
  {
    img: IMAGES.mist,
    title: "Fine mist on every press",
    caption: "Salad gets a light, even coat of oil",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    img: IMAGES.airfryer,
    title: "Made for air fryers",
    caption: "Light oil coat, extra-crispy food",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    img: IMAGES.pour,
    title: "Pours exactly right",
    caption: "No drips on your pan or stove",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    img: IMAGES.parts,
    title: "Easy to refill",
    caption: "Big mouth — pour oil in without spills",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
];

export const SCENES = [
  { img: IMAGES.box, sub: "Dekhiye kya aaya hai!" },
  { img: IMAGES.hero, sub: "Kitchen ka ultimate 2-in-1 upgrade." },
  { img: IMAGES.mist, sub: "Perfect misting…" },
  { img: IMAGES.pour, sub: "…and pour control." },
];

export const FAQS = [
  {
    q: "Can I wash it in the dishwasher?",
    a: "Yes. The glass bottle can go on the top rack of your dishwasher. For the green cap, a quick rinse under warm water keeps the spray working its best.",
  },
  {
    q: "Can I use thick oils or vinegar?",
    a: "Yes — olive, sunflower and sesame oil, vinegar, soy and lemon juice all work. For very thick liquids, use the pour mode instead of the spray.",
  },
  {
    q: "How fast will it reach me?",
    a: "Shipping is free. We pack your order within 24 hours and it reaches most places in 2–4 days (5–9 days for other countries). You get a tracking link by email.",
  },
  {
    q: "What if I don't like it?",
    a: "If anything's wrong with your bottle — damaged in transit, leaking, or not what you ordered — message us on WhatsApp with a photo within 48 hours of delivery and we ship a free replacement right away. Changed your mind before shipping? Cancel free from your tracking page. Real support, no bots.",
  },
];

export const REVIEWS = [
  {
    name: "Priya Sharma",
    city: "Mumbai",
    rating: 5,
    tag: "Air Fryer Owner",
    img: "https://images.unsplash.com/photo-1752920802442-f309a4670a5f?q=80&w=900&auto=format&fit=crop",
    text: "The mist is SO fine — my paneer tikka gets an even sheen with barely any oil. My air fryer nights have completely changed.",
  },
  {
    name: "Arjun Mehta",
    city: "Delhi",
    rating: 5,
    tag: "Daily Cook",
    img: "https://images.unsplash.com/photo-1758523418417-701393c2abae?q=80&w=900&auto=format&fit=crop",
    text: "Bought it for the handle, stayed for the pour. Not a single drip down the bottle, and it looks premium on the counter.",
  },
  {
    name: "Kavya Reddy",
    city: "Hyderabad",
    rating: 5,
    tag: "Salad Lover",
    img: "https://images.unsplash.com/photo-1625631980722-b728f9cf1036?q=80&w=900&auto=format&fit=crop",
    text: "Unboxed it, sprayed my salad and clicked this photo within the hour. The wide 470ml mouth makes refilling sunflower oil mess-free.",
  },
  {
    name: "Sneha Iyer",
    city: "Chennai",
    rating: 4,
    tag: "Home Baker",
    img: "https://images.pexels.com/photos/7488995/pexels-photo-7488995.jpeg?auto=compress&cs=tinysrgb&w=900",
    text: "Greasing tins used to be my least favourite step. Two presses and the tin is evenly coated. Wish the lever were a touch softer.",
  },
  {
    name: "Rohan Patel",
    city: "Ahmedabad",
    rating: 5,
    tag: "BBQ Enthusiast",
    img: "https://images.pexels.com/photos/6182692/pexels-photo-6182692.jpeg?auto=compress&cs=tinysrgb&w=900",
    text: "Zero leaks in my barbecue box, even half-full in the car. The glass feels thick and premium — worth every rupee of ₹349.",
  },
  {
    name: "Vikram Singh",
    city: "Jaipur",
    rating: 5,
    tag: "Healthy Cooking",
    img: "https://images.pexels.com/photos/9345673/pexels-photo-9345673.jpeg?auto=compress&cs=tinysrgb&w=900",
    text: "Switched from free-pouring oil to the mist and my daily calories dropped noticeably. Dal tadka still tastes exactly the same.",
  },
];
